import XLSX from 'xlsx';
export default {
	methods: 
    {	
		filterSelects(list)
		{
			return _.filter(this.lists[list],['id_list_estado',1])
		},
		async getFiltrar()
		{
			let dataRoute={}
			let others=[]
			let filterKeys= Object.keys(this.filter);
			for (let i = 0; i < filterKeys.length; i++) {				
				if(filterKeys[i]==='inicial')
				{
					(this.filter.inicial==='') ? dataRoute.inicial= this.fecha().inicioLabores.servicios : dataRoute.inicial= this.filter.inicial;
					
				}		
				if(filterKeys[i]==='final')
				{
					(this.filter.final==='') ? dataRoute.final= this.fecha().inicioLabores.servicios : dataRoute.final= this.filter.final;
				}	
				if(filterKeys[i]!=='inicial' && filterKeys[i]!=='final' && this.filter[filterKeys[i]]!=='' && this.filter[filterKeys[i]]!==null)
				{
					if(filterKeys[i]=='planilla')
					{
						others.push(['datos_afiliado.planilla',this.filter[filterKeys[i]]])						
					}
					else if(filterKeys[i]!='planilla')
					{
						others.push([filterKeys[i],this.filter[filterKeys[i]].id])
					}
				}	
			}
			dataRoute.others=others
			await this.getDataGet({ route: 'get_aportesinformes', data: dataRoute})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
		},	
		async getLimpiar()
		{
			this.filter = {
				inicial: this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null,
				id_datos_razon: null
			}
			await this.getDataGet({ route: 'get_aportesinformes', data: {others: []}})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
		},		
		getPdf()
		{/*
			if(this.tableSave.tableGetAportes.btn0.length>0)
			{
				let ids = []
				for (let index = 0; index < this.tableSave.tableGetAportes.btn0.length; index++) {
					if(this.tableSave.tableGetAportes.btn0[index].check)
					{
						ids.push(this.tableSave.tableGetAportes.btn0[index].archivo_plano.id)
					}	
				}
				if(ids.length>0)
				{
					window.open( this.url+'/api/pdf/aportes?ids='+ids.toString()+'&token='+this.token,'_blank')
				}				
			}
			*/
		},
		getExcell()
		{
			let dataToExport=[]  
			let dataPostArray= this.dataGet[this.namePath].data
			for (let m = 0; m < dataPostArray.length; m++)				
			{					
				let datosrazon=this.gettersDatalist('datos_razon',dataPostArray[m].archivo_plano.id_datos_razon)[0]
				let datosafiliado=this.gettersDatalist('datos_afiliado',dataPostArray[m].archivo_plano.id_datos_afiliado)[0]


				dataToExport.push([dataPostArray[m].archivo_plano.tipodocumento,dataPostArray[m].archivo_plano.documento.toString(),datosafiliado.nombre1,datosafiliado.nombre2,datosafiliado.apellido1,datosafiliado.apellido2,datosafiliado.telefonos,datosafiliado.email,this.gettersDatalist('datos_asesor',dataPostArray[m].archivo_plano.id_datos_asesor)[0].name,datosrazon.name,dataPostArray[m].archivo_plano.servicios,dataPostArray[m].archivo_plano.planilla,dataPostArray[m].archivo_plano.fechaplanilla, (datosafiliado.planilla===1) ? 'SI' : ''])
			}			
							
			let datae = XLSX.utils.json_to_sheet(dataToExport)              
			datae['A1'].v = 'Tipo'
			datae['B1'].v = 'Documento'
			datae['C1'].v = 'Nombre1'
			datae['D1'].v = 'Nombre2'
			datae['E1'].v = 'Apellido1'
			datae['F1'].v = 'Apellido2'
			datae['G1'].v = 'Telefonos'
			datae['H1'].v = 'Email'
			datae['I1'].v = 'Asesor'
			datae['J1'].v = 'Razon Social'
			datae['K1'].v = 'Servicios'
			datae['L1'].v = 'Planilla'
			datae['M1'].v = 'Fecha planilla'
			datae['N1'].v = 'Solicita'
			const workbook = XLSX.utils.book_new()
			const filename = 'aportes'+this.fecha().fecha.hoy
			XLSX.utils.book_append_sheet(workbook, datae, filename)
			XLSX.writeFile(workbook, `${filename}.xlsx`)	
		},	
	},
}